import { Box } from '@bechtel/gds';
import { MilestoneStatusCode } from '@bechtel/types';
import styled, { css } from 'styled-components';
import { WeldItemStyledProps } from '../types';

interface WeldStatusStyledProps {
  status: MilestoneStatusCode | undefined;
  isAssigned: boolean;
  hasBlocks?: boolean;
}

interface FitupStatusStyledProps {
  selected: boolean;
}

const getBackgroundColor = (props: WeldStatusStyledProps) => {
  switch (props.status) {
    case MilestoneStatusCode.APPROVED:
      return css`
        background-color: ${({ theme }) => theme.colors.green['300']};
        border: 1px solid ${({ theme }) => theme.colors.green['400']};
      `;
    case MilestoneStatusCode.CLAIMED:
      return css`
        background-color: ${({ theme }) => theme.colors.orange['300']};
        border: 1px solid ${({ theme }) => theme.colors.orange['400']};
      `;
    case MilestoneStatusCode.BLOCKED:
      return css`
        background-color: ${({ theme }) => theme.colors.red['300']};
        border: 1px solid ${({ theme }) => theme.colors.red['400']};
      `;
    case MilestoneStatusCode.REJECTED:
      return css`
        background-color: ${({ theme }) => theme.colors.purple['300']};
        border: 1px solid ${({ theme }) => theme.colors.purple['400']};
      `;
    case MilestoneStatusCode.REQUESTED:
      return css`
        background-color: ${({ theme }) => theme.colors.yellow['300']};
        border: 1px solid ${({ theme }) => theme.colors.yellow['400']};
      `;
    case MilestoneStatusCode.UNPLANNED: {
      return props.isAssigned
        ? css`
            background-color: ${({ theme }) => theme.colors.blue['300']};
            border: 1px solid ${({ theme }) => theme.colors.blue['400']};
          `
        : css`
            background-color: ${({ theme }) => theme.colors.grey['300']};
            border: 1px solid ${({ theme }) => theme.colors.grey['400']};
          `;
    }
    default:
      return css`
        background-color: transparent;
        border: 1px solid ${({ theme }) => theme.colors.grey['400']};
      `;
  }
};

export const WeldStatusStyled = styled(Box)<WeldStatusStyledProps>`
  ${({ theme }) => css`
    width: ${theme.spacings[800]};
    height: ${theme.spacings[300]};
    border-radius: ${theme.spacings[200]};
    margin-right: ${theme.spacings[400]};
  `}
  ${({ hasBlocks }) =>
    hasBlocks
      ? css`
          background: ${({ theme }) => theme.colors.red['400']};
          border: 1px solid ${({ theme }) => theme.colors.red['500']};
        `
      : getBackgroundColor}
`;

export const FitupStatusStyled = styled(Box)<FitupStatusStyledProps>`
  ${({ theme, selected }) => css`
    width: ${theme.spacings[800]};
    height: ${theme.spacings[300]};
    border-radius: ${theme.spacings[200]};
    margin-right: ${theme.spacings[400]};
    background-color: ${selected ? theme.colors.grey['300'] : 'transparent'};
    border-style: ${selected ? 'solid' : 'dashed'};
    border-width: 1px;
    border-color: ${theme.colors.grey['400']};
  `}
`;

export const WeldItemStyled = styled(Box).attrs({
  py: { sm: '450' },
  pl: { sm: '450' },
  pr: { sm: '500' },
})<WeldItemStyledProps>`
  &:hover {
    background-color: ${({ theme }) => theme.colors.bechtel.blue[100]};
  }
  background-color: ${(props: WeldItemStyledProps) =>
    props.isActive ? ({ theme }) => theme.colors.bechtel.blue[100] : ({ theme }) => theme.colors.white};

  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
`;
